import { cn } from '@seen/ui'
import { IconCheck } from '@tabler/icons-react'
import type { JSX, ReactNode } from 'react'
import { UserPlaceholderNameplate } from '#src/components/nameplates/UserPlaceholderNameplate.tsx'

export function UserPlaceholderOption({
  isSelected,
  children,
}: {
  isSelected?: boolean
  children: ReactNode
}): JSX.Element {
  return (
    <div className="flex flex-1 items-center justify-between">
      <UserPlaceholderNameplate>{children}</UserPlaceholderNameplate>
      <IconCheck
        className={cn(
          'mr-0.5 size-4 shrink-0 opacity-0',
          isSelected && 'opacity-100'
        )}
      />
    </div>
  )
}
